import { render, staticRenderFns } from "./expand.vue?vue&type=template&id=1bcef330&scoped=true"
import script from "./expand.vue?vue&type=script&lang=js"
export * from "./expand.vue?vue&type=script&lang=js"
import style0 from "./expand.vue?vue&type=style&index=0&id=1bcef330&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcef330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bcef330')) {
      api.createRecord('1bcef330', component.options)
    } else {
      api.reload('1bcef330', component.options)
    }
    module.hot.accept("./expand.vue?vue&type=template&id=1bcef330&scoped=true", function () {
      api.rerender('1bcef330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerContract/expand.vue"
export default component.exports